<template>
    <div class="version-update-page">
        <div class="global-header-wrap">
            <span>{{$route.query.editId ? $t('firmware.updateFirmware') : $t('firmware.addFirmware')}}</span>
            <button class="global-button-style" @click="$router.back()">{{$t('commonMsg.back')}}</button>
        </div>
        <el-card class="app-table-container" :body-style="{ padding: '20px' }" v-bar>        
            <div class="body-wrap">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" @submit.native.prevent label-width="100px" class="global-page-form">			
                    <el-form-item :label="$t('firmware.model')" prop="model">
                        <el-input v-model="ruleForm.model" :placeholder="$t('firmware.model')"></el-input>
                    </el-form-item>	
                    <el-form-item :label="$t('firmware.brand')" prop='brand'>
                        <el-input v-model="ruleForm.brand" :placeholder="$t('firmware.brand')"></el-input>
                    </el-form-item>		
                    <el-form-item :label="$t('firmware.versions')" prop='buildNumber'>
                        <el-input type="number" v-model="ruleForm.buildNumber" :placeholder="$t('firmware.versions')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('firmware.type')" prop='buildType'>
                        <el-input v-model="ruleForm.buildType" :placeholder="$t('firmware.type')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('firmware.lang')" prop='lang'>
                        <el-input v-model="ruleForm.lang" :placeholder="$t('firmware.lang')"></el-input>
                    </el-form-item> 
                    <el-form-item label="MD5" prop='md5'>
                        <el-input v-model="ruleForm.md5" placeholder="MD5"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('firmware.scrnW')" prop='widthPixels'>
                        <el-input type="number" v-model="ruleForm.widthPixels" :placeholder="$t('firmware.scrnW')"></el-input>
                    </el-form-item>		
                    <el-form-item :label="$t('firmware.scrnH')" prop='heightPixels'>
                        <el-input type="number" v-model="ruleForm.heightPixels" :placeholder="$t('firmware.scrnH')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('firmware.fingerprint')" prop='fingerprint'>
                        <el-input v-model="ruleForm.fingerprint" :placeholder="$t('firmware.fingerprint')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('firmware.upgrade')">
                        <el-input v-model="ruleForm.parentFingerprint" :placeholder="$t('firmware.upgrade')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('firmware.downLoad')">
                        <el-input type="textarea" v-model="downLoad" :placeholder="$t('firmware.downLoad')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('firmware.changeMsg')">
                        <el-input type="textarea" v-model="changeMsg" :placeholder="$t('firmware.changeMsg')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('firmware.MAC')">
                        <el-input type="textarea" v-model="deviceMac" :placeholder="$t('firmware.MACTip')"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <button class="global-button-style btn-style" @click="submitForm('ruleForm')">{{$t('commonMsg.save')}}</button>
                    </el-form-item>												 
                </el-form>
            </div>
        </el-card>        
    </div>
</template>

<script>
import upload from '@/components/upload'
export default {
    components: {
        upload
    },
    computed: {
        nameType() {
            switch (this.ruleForm.named_update) {
                case 1:
                    return '机构FID'
                    break;
                case 2:
                    return 'MAC'
                    break;
            
                default:
                    break;
            }
        },
        rules() {
            let ruleFn = (arr) => {
                if(!arr || !arr.length) return {}
                let obj = {}
                for(let item of arr) {
                    if(!obj.hasOwnProperty(item.name)) {
                        obj[item.name] = []
                        obj[item.name].push({required: true, message: this.$t(item.message), trigger: 'blur'})
                    }
                }
                return obj
            }     

            let rules = ruleFn([
                {name: 'model', message: 'verify.firmwareModel'},
                {name: 'brand', message: 'verify.firmwareBrand'},
                {name: 'buildNumber', message: 'verify.firmwareVersion'},
                {name: 'buildType', message: 'verify.firmwareType'},
                {name: 'lang', message: 'verify.firmwareLang'},
                {name: 'md5', message: 'verify.firmwareMD5'},
                {name: 'widthPixels', message: 'verify.firmwareScrnW'},                
                {name: 'heightPixels', message: 'verify.firmwareScrnH'},
                {name: 'fingerprint', message: 'verify.firmwareFingerprint'},
                {name: 'downloadUrlList', message: 'verify.firmwareDownload'}                
            ])

            return rules
        }
    },
    data() {
           

        return {
            deviceMac: '',
            changeMsg: '',
            downLoad: '',				
            ruleForm: {
                model : '',
                brand : '',
                buildNumber : 0,
                buildType : '',
                fingerprint : '',
                lang : '',
                md5 : '',
                widthPixels : 0,
                heightPixels : 0,
                parentFingerprint: '',
                deviceMAC : [],
                changeList : [],
                downloadUrlList : []
            },
           
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.deviceMAC = this.textareaDo(this.deviceMac)
                    this.ruleForm.changeList = this.textareaDo(this.changeMsg)
                    this.ruleForm.downloadUrlList = this.textareaDo(this.downLoad)			
                    this.ruleForm.buildNumber = Number(this.ruleForm.buildNumber)
                    this.ruleForm.widthPixels = Number(this.ruleForm.widthPixels)	
                    this.ruleForm.heightPixels = Number(this.ruleForm.heightPixels)
                    this.$route.query.editId ? this.editSave() : this.addSave()							
                } else {
                    return false;
                }
            })
        },

        textareaDo(value){
            if(!value) return [] 
            let tempValue = value.replace(/(\n|\r|\n\r)/g, '#￥#￥#')
            let result = tempValue.split('#￥#￥#')
            return result;
        },			
        textareaUndo(value){
            if(!value) return;
            let resultValue = value.join('\n')
            return resultValue;
        },

        addSave(){
            this.$http.addFirmware(this.ruleForm)
            .then(res => {
                this.$message({message : this.$t('alertMsg.addSuccess'), duration : 2000, type: 'success'});
                this.$router.back()
            })
            .catch(err => {
                this.$message({message : err, duration : 2000, type: 'error'});
            })            	
        },
        editSave(){
            this.$http.editFirmware(this.$route.query.editId, this.ruleForm)
            .then(res => {
                this.$message({message : this.$t('alertMsg.editSuccess'), duration : 2000, type: 'success'});
                this.$router.back()
            })
            .catch(err => {
                this.$message({message : err, duration : 2000, type: 'error'});
            })				
        },

        getSingleFirmware(id) {
            this.$http.getSingleFirmware(id)
            .then(res => {
                this.ruleForm = res.data
                this.deviceMac = this.textareaUndo(res.data.deviceMAC)
                this.changeMsg = this.textareaUndo(res.data.changeList)
                this.downLoad = this.textareaUndo(res.data.downloadUrlList)
            })
            .catch(err => {
                this.$message({message : err, duration : 2000, type: 'error'});
            })             
        }
    },
    created() {
        if(!this.$route.query.editId) return
        this.getSingleFirmware(this.$route.query.editId)
    }
    
}
</script>

<style lang="scss">
    .version-update-page{
        height: 100%;
        display: flex;
        flex-direction: column;
        .body-wrap{
            height: 100%;
            .el-form{
                width: 70%;
                min-width: 500px;
                margin: 10px auto;
                .el-form-item{
                    .el-select{
                        width: 100%;
                    }
                    .el-textarea__inner{
                        height: 150px;
                    }
                }
                .btn-style{
                    width: 100%;
                    margin: 0;
                }              
            }
        }
    }
</style>
